import { render, staticRenderFns } from "./ProgramConcentrationsSelectbox.vue?vue&type=template&id=184358b9&"
import script from "./ProgramConcentrationsSelectbox.vue?vue&type=script&lang=js&"
export * from "./ProgramConcentrationsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports